<app-base-modal modalName=""
  [inProcessModal]="inProcessModal"
  [customCloseAction]="closeXSellModal.bind(this)"
  [hideClose]="false">
  <ng-template>
    <div class="scrollable-modal-section">
      <div class="xsell-hhrenewal-container"
        appDropdownEvent>
        <div class="xsell-header-wrapper">
          @if (!hasRenewalMonth) {
            <img
              src="./assets/images/reskins/info-outline.svg"
              alt="info-outline"
              aria-label="info-outline">
          }
          @if (hasRenewalMonth) {
            <img
              src="./assets/images/reskins/success.svg"
              alt="success-icon"
              aria-label="success-icon">
          }
          <div class="xsell-header-section">
            <span class="xsell-title">{{hasRenewalMonth?s.onTouch:s.chooseMonthTitle}}</span>
            @if (!hasRenewalMonth) {
              <span class="xsell-title-info"
              >{{s.chooseMonthTitleInfo}}</span>
            }
          </div>
        </div>

        <div class="renewal-dropdown-wrapper">
          <form [formGroup]="xSellForm"
            class="xsell-form"
            id="xsell-form">
            <app-question-dropdown [questionText]="s.renewalMonth"
              [optionsList]="monthsList"
              placeholder="Select..."
              formControlName="xSellMonths"
              [fullWidth]="true"
              [gtmEventId]="gtmEventIds.hhMonth"
              (OnChange)="handleMonthSelected($event)"
              [disabledInput]="monthSelected">
            </app-question-dropdown>

            <div class="optional-text"
              [ngClass]="{ 'disabled' : hasRenewalMonthSelected }">
              <img class="notification-icon"
                [src]="'./assets/images/icons/Info.svg'"
                width="16"
                height="16"
                aria-label="info-icon"
                alt="info-icon">
                <span class="notification-text">
                  {{s.optional}}
                </span>
              </div>
            </form>
            <div class="booklet-section">
              <span>{{s.readPolicy}} </span>
              <a class="hyperlink"
                id="policy_booklet"
                (click)="openMotorPolicyLink(s.policyBookletLink, $event)">
                <span class="hyperlink-icon"
                alt="hyperlink-icon"></span>
                <span class="hyperlink-text">{{s.policyBooklet}}</span>
              </a>
            </div>

            @if (hasRenewalMonth===false) {
              <button id="xsell_lead_submitted"
                class="app-submit-btn"
                (click)="handleContinueSelected($event)"
                >
                {{s.continueBtn}}
                <img src="./assets/images/reskins/heavy-arrow-left-white.svg"
                  alt="heavy-arrow-left-white"
                  aria-label="heavy-arrow-left-white">
                </button>
              }

              @if (hasRenewalMonth) {
                <div class="xsell-now"
                  >
                  <div class="xsell-now-header-wrapper">
                    <span class="xsell-now-title">{{s.getNow}}</span>
                    <span class="xsell-now-info">{{s.xSellNowQn}}</span>
                  </div>
                  <div class="xsell-button-container">
                    <div [formGroup]="xSellOptionForm">
                      <app-question-buttons [optionsList]="xSellOptionsList"
                        formControlName="xSellJourneyOption"
                        [gtmEventId]="gtmEventIds.xSellJourneyOptionPopup"
                        [hasGtmEventId]="true"
                        [fullRow]="true"
                        id="xsell-popup">
                      </app-question-buttons>
                      <button id="xsell_get_started_popup"
                        (click)="onGetStarted($event)"
                        class="app-submit-btn-primary"
                        [disabled]="xSellOptionForm.invalid">
                        <img class="hyperlink-icon"
                          alt="link-icon"
                          aria-label="link-icon">
                          {{s.getStartedBtn}}
                        </button>
                      </div>
                    </div>
                  </div>
                }
              </div>

              @if (hasRenewalMonth===true) {
                <button class="app-submit-btn"
                  (click)="closeXSellModal()"
                  >
                  {{s.closeBtn}}
                </button>
              }
            </div>
          </div>


        </ng-template>
      </app-base-modal>